import React from 'react';

const Separator = () => (
  <div className="transition duration-500 h-[100px] md:h-[200px]">
    <svg className="transition duration-500 fill-gray-200 bg-gray-100 dark:fill-gray-700 dark:bg-gray-800 w-[100vw] h-[100%]" viewBox="0 0 500 150" preserveAspectRatio="none">
      <path d="M0.00,49.98 C149.99,150.00 349.20,-49.98 500.00,49.98 L500.00,150.00 L0.00,150.00 Z" />
    </svg>
  </div>
);

export default Separator;
